<div class="alert mb-10" [ngClass]="(serverResponse ? 'alert-success' : 'alert-danger')">
    <ng-content select=".success-content"></ng-content>
    <ng-content select=".error-content"></ng-content>
</div>
